import ErrorContainer from 'widget/Errors/ErrorView/primitives/ErrorContainer';
import ErrorHeading from 'widget/Errors/ErrorView/primitives/ErrorHeading';
import ErrorIHeartLink from 'widget/Errors/ErrorView/primitives/ErrorIHeartLink';
import ErrorText from 'widget/Errors/ErrorView/primitives/ErrorText';
import ErrorTextLink from 'widget/Errors/ErrorView/primitives/ErrorTextLink';
import getErrorMsg from 'widget/Errors/ErrorView/helpers/getErrorMsg';
import { HttpErrorCode } from 'widget/Errors/types/HttpErrorCode';
import { useTranslate } from 'widget/hooks';

export type Props = {
  httpStatus: HttpErrorCode | number;
};

export default function ErrorView({ httpStatus = 500 }: Props) {
  const translate = useTranslate();

  const { heading, link, text } = getErrorMsg(httpStatus, translate);

  return (
    <ErrorContainer data-test={`error-container-${httpStatus}`}>
      {/*
      // @ts-ignore */}
      <ErrorIHeartLink data-test="error-iheart-link" />
      <ErrorHeading data-test="error-heading">{heading}</ErrorHeading>
      <ErrorText data-test="error-text">{text}</ErrorText>
      <ErrorTextLink data-test="error-text-link" {...link} />
    </ErrorContainer>
  );
}
